import React from "react";
import { string, bool, func } from "prop-types";
import * as style from "./styles.module.scss";

const RadioButton = ({
  label,
  isChecked,
  onClick,
  classes,
  isDisabled,
  inputId = "",
}) => (
  <label
    className={`${style.radioButton__label} mr-1 ${classes || ""} ${
      isDisabled && style.radioButton__disabled
    }`}
  >
    <input
      type="radio"
      className={`${style.radioButton} mr-1`}
      onChange={onClick}
      checked={isChecked}
      autoComplete="off"
      disabled={isDisabled}
      id={inputId}
    />
    <span className={style.radioButton__checkmark}></span>
    {label}
  </label>
);

RadioButton.propTypes = {
  label: string,
  isChecked: bool,
  isDisabled: bool,
  onClick: func,
  classes: string,
  inputId: string,
};

export default RadioButton;
